import {useQuery} from '@tanstack/react-query';

import {STORAGE_CROPS, StorageCrop, StorageCropId} from './data/storageAshTransport';

type Input = {
  fuelCombusted?: number;
  cropId?: StorageCropId;
};

type Output = {
  crop?: StorageCrop;
  annualAsh?: number;
};

export function calculateAshDisposal({fuelCombusted, cropId}: Input): Output {
  const crop = cropId ? STORAGE_CROPS[cropId] : undefined;
  const annualAsh = crop !== undefined && fuelCombusted !== undefined ? (crop.ash / 100) * fuelCombusted : undefined;

  return {
    crop,
    annualAsh,
  };
}

export function useAshDisposalCalculator(input: Input) {
  return useQuery({
    queryKey: [...Object.values(input)],
    queryFn: () => calculateAshDisposal(input),
  });
}
